<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
		</div>
	</div>
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tAllocation:edit" permsDelete="sys:tAllocation:delete" :displayOperation1Button="false" :displayButtonEdit="false" :displayButtonDelete="false" :showBatchDelete="false"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.edit')" :buttonDelete="$t('action.delete')" :batchDelete="$t('action.batchDelete')" :pageNum=this.pageRequest.pageNum :pageSize=this.pageRequest.pageSize
		@findPage="findPage" @handleEdit="handleEdit" @handleDelete="handleDelete">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item label="" prop="id"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.id" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.pickId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="itemNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.itemNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickLocation"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.pickLocation" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickingFlow"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.pickingFlow" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickArea"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.pickArea" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="lotNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.lotNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="storedAttributeId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.storedAttributeId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="quantity"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.quantity" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="holdReasonId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.holdReasonId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="workType"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.workType" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="createDate"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.createDate" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="pickRule"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.pickRule" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="mhuId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.mhuId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="MUserAssigned"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.MUserAssigned" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TAllocation',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
			filters: {
				id: 0
			},
			columns: [
				{prop:"id", label:"TAllocation.id", minWidth:100},
        {prop:"pickId", label:"TAllocation.pickId", minWidth:100},
				{prop:"whId", label:"TAllocation.whId", minWidth:100},
				{prop:"itemNumber", label:"TAllocation.itemNumber", minWidth:100},
				{prop:"pickLocation", label:"TAllocation.pickLocation", minWidth:100},
				{prop:"pickingFlow", label:"TAllocation.pickingFlow", minWidth:100},
				{prop:"pickArea", label:"TAllocation.pickArea", minWidth:100},
				{prop:"lotNumber", label:"TAllocation.lotNumber", minWidth:100},
				{prop:"quantity", label:"TAllocation.quantity", minWidth:100},
				{prop:"holdReasonId", label:"TAllocation.holdReasonId", minWidth:100},
				{prop:"workType", label:"TAllocation.workType", minWidth:100},
				{prop:"createDate", label:"TAllocation.createDate", minWidth:100},
				{prop:"pickRule", label:"TAllocation.pickRule", minWidth:100},
				{prop:"mhuId", label:"TAllocation.MHuId", minWidth:100},
				{prop:"MUserAssigned", label:"TAllocation.MUserAssigned", minWidth:100},
        {prop:"storedAttributeId", label:"TAllocation.storedAttributeId", minWidth:100},
        {prop:"genericAttrValue1", label:"attributes.genericAttrValue1", minWidth:100, display:false},
        {prop:"genericAttrValue2", label:"attributes.genericAttrValue2", minWidth:100, display:false},
        {prop:"genericAttrValue3", label:"attributes.genericAttrValue3", minWidth:100, display:false},
        {prop:"genericAttrValue4", label:"attributes.genericAttrValue4", minWidth:100, display:false},
        {prop:"genericAttrValue5", label:"attributes.genericAttrValue5", minWidth:100, display:false},
        {prop:"genericAttrValue6", label:"attributes.genericAttrValue6", minWidth:100, display:false},
        {prop:"genericAttrValue7", label:"attributes.genericAttrValue7", minWidth:100, display:false},
        {prop:"genericAttrValue8", label:"attributes.genericAttrValue8", minWidth:100, display:false},
        {prop:"genericAttrValue9", label:"attributes.genericAttrValue9", minWidth:100, display:false},
        {prop:"genericAttrValue10", label:"attributes.genericAttrValue10", minWidth:100, display:false},
        {prop:"genericAttrValue11", label:"attributes.genericAttrValue11", minWidth:100, display:false},
        {prop:"genericAttrShow1", label:"attributes.genericAttrShow1", minWidth:100},
        {prop:"genericAttrShow2", label:"attributes.genericAttrShow2", minWidth:100},
        {prop:"genericAttrShow3", label:"attributes.genericAttrShow3", minWidth:100},
        {prop:"genericAttrShow4", label:"attributes.genericAttrShow4", minWidth:100},
        {prop:"genericAttrShow5", label:"attributes.genericAttrShow5", minWidth:100},
        {prop:"genericAttrShow6", label:"attributes.genericAttrShow6", minWidth:100},
        {prop:"genericAttrShow7", label:"attributes.genericAttrShow7", minWidth:100},
        {prop:"genericAttrShow8", label:"attributes.genericAttrShow8", minWidth:100},
        {prop:"genericAttrShow9", label:"attributes.genericAttrShow9", minWidth:100},
        {prop:"genericAttrShow10", label:"attributes.genericAttrShow10", minWidth:100},
        {prop:"genericAttrShow11", label:"attributes.genericAttrShow11", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 1000 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
				// label: [
				// 	{ required: true, message: '请输入名称', trigger: 'blur' }
				// ]
			},
			// 新增编辑界面数据
			dataForm: {
				id: null,
				whId: null,
				pickId: null,
				itemNumber: null,
				pickLocation: null,
				pickingFlow: null,
				pickArea: null,
				lotNumber: null,
				storedAttributeId: null,
				quantity: null,
				holdReasonId: null,
				workType: null,
				createDate: null,
				pickRule: null,
				mhuId: null,
				MUserAssigned: null,
}
}
	},
	methods: {
    getParentParams: function () {
      this.filters.id=this.$route.query.id
      this.findPage(null)
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			this.pageRequest.columnFilters = {id:{name:"id",value:this.filters.id}}
			this.$wmsApi.tAllocation.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
		// 批量删除
		handleDelete: function (data) {
			this.$wmsApi.tAllocation.batchDelete(data.params).then(data!=null?data.callback:'')
		},
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				id: null,
				whId: null,
				pickId: null,
				itemNumber: null,
				pickLocation: null,
				pickingFlow: null,
				pickArea: null,
				lotNumber: null,
				storedAttributeId: null,
				quantity: null,
				holdReasonId: null,
				workType: null,
				createDate: null,
				pickRule: null,
				mhuId: null,
				MUserAssigned: null,
}
},
		// 显示编辑界面
		handleEdit: function (params) {
			this.editDialogVisible = true
			this.operation = false
			this.dataForm = Object.assign({}, params.row)
		},
		// 编辑
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						this.editLoading = true
						let params = Object.assign({}, this.dataForm)
						this.$wmsApi.tAllocation.save(params).then((res) => {
							if(res.code == 200) {
								this.$message({ message: this.$t("common.message.success")+'', type: 'success' })
				}
else {
								this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				}
this.editLoading = false
							this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							this.findPage(null)
						})
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
    return format(row[column.property])
    }
	},
  activated: function () {
    this.getParentParams()
  },
	mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TAllocation.vue